module.exports = __webpack_public_path__ + "static/media/9DESA16.71aa7209.jpg";